import generadas from "../../lib/fotosGeneradas.json";

/**
 * Fotografia responsiva. Sirve WebP con respaldo JPEG y deja que el navegador
 * elija el ancho segun la pantalla.
 *
 * `nombre` es la clave de la foto (p. ej. "plegadora"); los archivos los
 * genera `npm run imagenes` en /public/maquinas.
 *
 * Los anchos del srcset NO estan escritos a mano: salen del manifiesto que
 * escribe ese script con lo que realmente se genero. Si un original es chico
 * (la roladora mide 820 px), su srcset lista solo 800w en vez de prometer un
 * 2000w que en realidad seria una imagen de 820 px estirada.
 *
 * `prioridad` se usa solo en la imagen de portada: la carga de inmediato y le
 * pide al navegador que la priorice, por ser el elemento mas grande de la
 * primera pantalla.
 */
export default function Foto({
  nombre,
  alt,
  className = "",
  sizes = "(max-width: 700px) 100vw, 50vw",
  prioridad = false,
}) {
  const info = generadas[nombre];

  if (!info) {
    // Falta correr `npm run imagenes` para esta foto: mejor no romper la pagina.
    if (import.meta.env.DEV) {
      console.warn(
        `[Aceros Lima] No hay variantes generadas para "${nombre}". Ejecuta: npm run imagenes`
      );
    }
    return null;
  }

  const base = `/maquinas/${nombre}`;
  const srcSet = (ext) =>
    info.anchos.map((a) => `${base}-${a}.${ext} ${a}w`).join(", ");

  return (
    <picture>
      <source type="image/webp" srcSet={srcSet("webp")} sizes={sizes} />
      <source type="image/jpeg" srcSet={srcSet("jpg")} sizes={sizes} />
      <img
        className={className}
        src={`${base}.jpg`}
        alt={alt}
        width={info.anchoOriginal}
        height={info.altoOriginal}
        loading={prioridad ? "eager" : "lazy"}
        decoding={prioridad ? "sync" : "async"}
        // React 18 pasa este atributo tal cual solo en minusculas; el camelCase
        // `fetchPriority` recien lo entiende React 19. La regla de eslint
        // asume React 19, asi que aqui se desactiva a proposito.
        // eslint-disable-next-line react/no-unknown-property
        fetchpriority={prioridad ? "high" : undefined}
      />
    </picture>
  );
}
